// import React from "react";
// import css from "./popUp.module.css";

// const PopUpEur = React.forwardRef((props, ref) => {
//   return (
//     <div className={css.dropPopWrap} ref={ref}>
//       <p className={css.mainPopP}>
//         Відтепер наші видання можна замовити з швидкою доставкою по Європі.
//         <br />
//         Офіційній дистриб'ютор Видавництво Час Майстрів" у ЄС (Польща м.
//         Краків): Міла Радченко <a href="tel:+48790820066">
//           +48 790 820 066
//         </a>{" "}
//         <a href="mailto:mila@chasmaistriv.com.ua">mila@chasmaistriv.com.ua</a>{" "}
//         реєструєтесь зі статусом "Дропшипінг"; зручний сервіс замовлення на
//         сайті в розділі "Прайс-гурт", зручний довіз, звіти.
//       </p>
//     </div>
//   );
// });

// export default PopUpEur;
// src/components/PopUpEur.jsx
import React from "react";
import css from "./popUp.module.css";
import { db } from "../../firebase"; // підкоригуй шлях під свій
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "books_chm_europe"; // popups/books_chm_europe

const PopUpEur = React.forwardRef((props, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);
      setHtml(snap.exists() ? snap.data()?.contentHtml || "" : "");
    });
    return () => unsub();
  }, []);

  return (
    <div className={css.dropPopWrap} ref={ref} onClick={props?.onClick}>
      <div
        className={`${css.mainPopP}`}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default PopUpEur;
